import { AppRoutes } from "@/constants.ts";
import type { RequiresAction } from "../types/login.types";

/** Route targets for login required-action flags (email verification stays inline). */
const ACTION_ROUTE_PRIORITY: ReadonlyArray<{
  action: keyof RequiresAction;
  route: string;
}> = [
  { action: "billingAccountIssue", route: AppRoutes.billingAccountIssue },
  { action: "subscriptionActivation", route: AppRoutes.subscriptionExpired },
  { action: "paymentUpdate", route: AppRoutes.paymentUpdate },
  { action: "paymentUpdated", route: AppRoutes.paymentUpdate },
];

/**
 * Return the first route for a set of login required actions, if any.
 */
export function getRequiredActionRoute(
  requiresAction: RequiresAction | undefined
): string | null {
  if (!requiresAction) {
    return null;
  }
  for (const { action, route } of ACTION_ROUTE_PRIORITY) {
    if (requiresAction[action]) {
      return route;
    }
  }
  return null;
}

/**
 * List required-action keys that are true on the login payload.
 */
export function listRequiredActions(
  requiresAction: RequiresAction | undefined
): string[] {
  return Object.entries(requiresAction ?? {})
    .filter(([, value]) => value)
    .map(([key]) => key);
}

/**
 * Navigate to the dedicated page for a required action, when one exists.
 */
export function redirectForRequiredActions(
  requiresAction: RequiresAction | undefined
): boolean {
  const route = getRequiredActionRoute(requiresAction);
  if (!route) {
    return false;
  }
  window.location.assign(route);
  return true;
}
